var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "institution-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            model: _vm.edit,
            elem: _vm.institutionElem,
            rules: _vm.institutionRule,
            "label-width": 100,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "机构名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入机构名称",
                              clearable: "",
                              maxlength: "125",
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "name", $$v)
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "子机构名称", prop: "subordinate" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入子机构名称",
                              clearable: "",
                              maxlength: "125",
                            },
                            model: {
                              value: _vm.edit.subordinate,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "subordinate", $$v)
                              },
                              expression: "edit.subordinate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "责任医生", prop: "doctor" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入责任医生",
                              clearable: "",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.doctor,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "doctor", $$v)
                              },
                              expression: "edit.doctor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "前缀", prop: "prefixs" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: true,
                              placeholder: "系统自动生成",
                              maxlength: "3",
                              disabled: true,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.toInt()
                              },
                            },
                            model: {
                              value: _vm.edit.prefixs,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "prefixs", $$v)
                              },
                              expression: "edit.prefixs",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "联系电话", prop: "phone" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入联系电话",
                              clearable: "",
                              maxlength: "15",
                            },
                            model: {
                              value: _vm.edit.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "phone", $$v)
                              },
                              expression: "edit.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "联系地址", prop: "address" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入联系地址",
                              clearable: "",
                              maxlength: "100",
                            },
                            model: {
                              value: _vm.edit.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "address", $$v)
                              },
                              expression: "edit.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入备注",
                              clearable: true,
                              maxlength: "1024",
                            },
                            model: {
                              value: _vm.edit.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remark", $$v)
                              },
                              expression: "edit.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "模版", prop: "analysisTemplateId" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择模版",
                                clearable: "",
                                filterable: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.edit.analysisTemplateId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.edit,
                                    "analysisTemplateId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "edit.analysisTemplateId",
                              },
                            },
                            _vm._l(_vm.analysisList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (!_vm.edit.id && _vm.userType <= 3) ||
                        (!_vm.edit.id &&
                          (_vm.edit.provinceCode || _vm.userType == 4)),
                      expression:
                        "(!edit.id && userType <= 3) || (!edit.id && (edit.provinceCode || userType == 4))",
                    },
                  ],
                },
                [
                  !_vm.edit.id && _vm.userType <= 3
                    ? _c(
                        "Col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "省份",
                                prop: "provinceCode",
                                required:
                                  !_vm.edit.id && _vm.userType <= 3
                                    ? true
                                    : false,
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: { "on-change": _vm.changeProvince },
                                  model: {
                                    value: _vm.edit.provinceCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.edit, "provinceCode", $$v)
                                    },
                                    expression: "edit.provinceCode",
                                  },
                                },
                                _vm._l(_vm.provinceList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.code,
                                      staticStyle: { width: "100%" },
                                      attrs: { value: item.code },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.edit.id && (_vm.edit.provinceCode || _vm.userType == 4)
                    ? _c(
                        "Col",
                        {
                          attrs: {
                            span: !_vm.edit.id && _vm.userType <= 3 ? 12 : 24,
                          },
                        },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "城市",
                                prop: "cityCode",
                                required:
                                  !_vm.edit.id &&
                                  (_vm.edit.provinceCode || _vm.userType == 4)
                                    ? true
                                    : false,
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: { "on-change": _vm.changeCity },
                                  model: {
                                    value: _vm.edit.cityCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.edit, "cityCode", $$v)
                                    },
                                    expression: "edit.cityCode",
                                  },
                                },
                                _vm._l(_vm.cityList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.code,
                                      staticStyle: { width: "100%" },
                                      attrs: { value: item.code },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "Row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (!_vm.edit.id &&
                          (_vm.edit.cityCode || _vm.userType == 5)) ||
                        (!_vm.edit.id && _vm.edit.areaCode),
                      expression:
                        "(!edit.id && (edit.cityCode || userType == 5)) || (!edit.id && edit.areaCode)",
                    },
                  ],
                  attrs: {
                    required:
                      (!_vm.edit.id &&
                        (_vm.edit.cityCode || _vm.userType == 5)) ||
                      (!_vm.edit.id && _vm.edit.areaCode)
                        ? true
                        : false,
                  },
                },
                [
                  !_vm.edit.id && (_vm.edit.cityCode || _vm.userType == 5)
                    ? _c(
                        "Col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "区", prop: "areaCode" } },
                            [
                              _c(
                                "Select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: { "on-change": _vm.changeArea },
                                  model: {
                                    value: _vm.edit.areaCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.edit, "areaCode", $$v)
                                    },
                                    expression: "edit.areaCode",
                                  },
                                },
                                _vm._l(_vm.areaList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.code,
                                      staticStyle: { width: "100%" },
                                      attrs: { value: item.code },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.edit.id && _vm.edit.areaCode
                    ? _c(
                        "Col",
                        {
                          attrs: {
                            span:
                              !_vm.edit.id &&
                              (_vm.edit.cityCode || _vm.userType == 5)
                                ? 12
                                : 24,
                          },
                        },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "街道",
                                prop: "streetCode",
                                required:
                                  !_vm.edit.id && _vm.edit.areaCode
                                    ? true
                                    : false,
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.edit.streetCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.edit, "streetCode", $$v)
                                    },
                                    expression: "edit.streetCode",
                                  },
                                },
                                _vm._l(_vm.streetList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.code,
                                      staticStyle: { width: "100%" },
                                      attrs: { value: item.code },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }